'use client';

import { useState } from 'react';

import { Container, Content, HoverBackground } from './subscribe-button.elements';

const SubscribeButton = ({ children }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Container onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <Content>{children}</Content>
      <HoverBackground $visible={isHovered} />
    </Container>
  );
};

export { SubscribeButton };
